import { UseToastOptions } from '@chakra-ui/react'

import { t } from '@/lib/helpers'
import { ERROR_TOAST_CONFIG, TOAST_CONFIG } from '@/lib/constants'

import { PollingResponse, ScanFailureReason } from '@/features/types'

const I18N_PREFIX = 'views.features.domains.index'

// Reasons where the customer's site could not be loaded. Anything else
// (`scanner_error`) is our scanner's problem, so the customer can only retry.
const SITE_REASONS: ScanFailureReason[] = [
  'dns_not_found',
  'connection_failed',
  'timed_out',
  'redirect_loop',
  'certificate_error',
  'site_unreachable',
]

export const scanResultToast = (job: PollingResponse): UseToastOptions => {
  const { urls = [], error_urls = [], failure_reason, url } = job.data || {}

  if (job.status === 'failed') {
    if (failure_reason && SITE_REASONS.includes(failure_reason)) {
      return {
        ...ERROR_TOAST_CONFIG,
        description: t(`${I18N_PREFIX}.scan_failed_site`, {
          url,
          reason: t(`${I18N_PREFIX}.scan_failed_reasons.${failure_reason}`),
        }),
        duration: null,
      }
    }

    if (failure_reason === 'scanner_error') {
      return {
        ...ERROR_TOAST_CONFIG,
        description: t(`${I18N_PREFIX}.scan_failed_scanner`),
        duration: null,
      }
    }

    // Older jobs, and failures raised before any page was tried, carry no reason.
    return {
      ...ERROR_TOAST_CONFIG,
      description: t(`${I18N_PREFIX}.scan_failed`),
      duration: null,
    }
  }

  if (error_urls.length > 0) {
    return {
      ...TOAST_CONFIG,
      status: 'warning',
      title: t('views.shared.toast.warning.title'),
      description: t(`${I18N_PREFIX}.scan_partial`, {
        scanned: urls.length,
        total: urls.length + error_urls.length,
        failed: error_urls.length,
      }),
      duration: null,
    }
  }

  return {
    ...TOAST_CONFIG,
    description: t(`${I18N_PREFIX}.scan_success`),
    duration: null,
  }
}
